module.exports = __webpack_public_path__ + "assets/ic-etherscan.e219ef64.svg";